import React from 'react';
import PropTypes from 'prop-types';
import EventDescription from './EventDescription';
import { getWsInterface } from '~spa/Utils/Websockets.js';

/**
 * This file is a copy of client/src/shared/components/react/Scoreboard/Scoreboard.jsx
 * with minimal modifications to for use with the EventDescription component.
 * @deprecated 2022-09 If your event comes from the CommonDataStore you can (and should) use
 * <EventDescription /> directly to avoid unnessary re-renders and issues with webSocket (un)register
 * requests being sent multiple times.
 * Still used by the InplayWidgetContainer (e.g. live featured on home page)
 */
class EventDescriptionWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.wsInterface = getWsInterface();
        this.wsConnected = false;
        this.wsInplayHandler = null;
        this.wsHandlerContext = `EventDescriptionWrapper/e-${props.event.id}`;

        this.getEventsSubscriptionList = this.getEventsSubscriptionList.bind(this);
        this.handleConnect = this.handleConnect.bind(this);
        this.handleUpdateEvents = this.handleUpdateEvents.bind(this);

        this.state = { event: props.event };
    }

    static propTypes = {
        event: PropTypes.object.isRequired,
        hasBoostedOddsSelections: PropTypes.bool,
    };

    componentDidMount() {
        if (!this.wsInplayHandler) {
            this.wsInplayHandler = this.wsInterface.requestHandler('mainSocket');
        }

        if (this.wsInplayHandler) {
            this.wsInplayHandler.onConnection(this.handleConnect, true);
        }
    }

    getEventsSubscriptionList() {
        try {
            const markets = Object.keys(this.props.event.markets);

            return [{
                event_id: parseInt(this.props.event.id, 10),
                market_id: parseInt(markets[0], 10),
            }];
        } catch (e) {
            return [];
        }
    }

    handleConnect() {
        if (!this.wsConnected) {
            this.wsInplayHandler.subscribe(this.getEventsSubscriptionList());
            this.handleUpdate();
            this.wsConnected = true;
        }
    }

    handleUpdate() {
        this.wsInplayHandler.registerHandler('inplay_update', this.handleUpdateEvents, this.wsHandlerContext);
        this.wsInplayHandler.registerHandler('price_update', this.handleUpdateEvents, this.wsHandlerContext);
    }

    handleUpdateEvents(msg) {
        msg.events.forEach((ev) => {
            if (this.props.event.id === ev.id) {
                this.setState(({event: previousEventState}) => ({
                    event: {
                        ...previousEventState,
                        ...ev,
                        extra_info: {
                            ...previousEventState.extra_info,
                            ...ev.extra_info,
                        },
                    },
                }));
            }
        });
    }

    componentWillUnmount () {
        if (this.wsConnected) {
            this.wsInplayHandler.unsubscribe(this.getEventsSubscriptionList());
        }
        if (this.wsInplayHandler) {
            this.wsInplayHandler.removeHandlers(this.wsHandlerContext);
        }
    }

    render() {
        return (
            <EventDescription
                { ...this.props }
                event={this.state.event}
            />
        );
    }
}

export default EventDescriptionWrapper;
